<template>
<div class="chapter">
<div class="inner_page">
<div class="boxnote">
<h2 class="h2d"><a id="page_6"></a><a id="page_7"></a>A NOTE CONCERNING MEASUREMENTS</h2>
</div>
<p class="noindent1">Though her later victories rendered the full terms of the Lisbon Accords moot, the Méxica Empire abides by the common set of weights and measures set forth by the Accords in <span class="small">A.D</span>. 1724. As a result, distances are in kilometers, weights in kilograms and so on.</p>
<h2 class="h2b">OFFICER RANKS OF THE IMPERIAL MÉXICAFLEET, ARMY AND MARINES</h2>
<table border="0" cellpadding="0" cellspacing="0" width="99%">
<tbody><tr>
<td valign="top"><p class="table"><span class="small">NISEI TERM</span></p></td>
<td valign="top"><p class="table"><span class="small">FLEET RANK</span></p></td>
<td valign="top"><p class="table"><span class="small">MARINE/ARMY</span></p></td>
<td valign="top"><p class="table"><span class="small">MÉXICA TERM</span></p></td>
</tr>
<tr>
<td valign="top"><p class="table">Thai-sho</p></td>
<td valign="top"><p class="table">Admiral</p></td>
<td valign="top"><p class="table">General</p></td>
<td valign="top"><p class="table">Cuauhnochteuctli<br/><em>(<span class="small">EAGLE PRICKLY-PEARL LORD</span>)</em></p></td>
</tr>
<tr>
<td valign="top"><p class="table">Chu-sho</p></td>
<td valign="top"><p class="table">Vice Admiral</p></td>
<td valign="top"><p class="table">Lieutenant-General</p></td>
<td valign="top"><p class="table"> </p></td>
</tr>
<tr>
<td valign="top"><p class="table">Sho-sho</p></td>
<td valign="top"><p class="table">Rear Admiral</p></td>
<td valign="top"><p class="table">Major-General</p></td>
<td valign="top"><p class="table">Tlacoccalcatl<br/><em>(<span class="small">COMMANDING GENERAL</span>)</em></p></td>
</tr>
<tr>
<td valign="top"><p class="table">Thai-sa</p></td>
<td valign="top"><p class="table">Captain</p></td>
<td valign="top"><p class="table">Colonel</p></td>
<td valign="top"><p class="table">Tlacateccatl<br/><em>(<span class="small">GENERAL</span>)</em></p></td>
</tr>
<tr>
<td valign="top"><p class="table">Chu-sa</p></td>
<td valign="top"><p class="table">Commander</p></td>
<td valign="top"><p class="table"> </p></td>
<td valign="top"><p class="table">Cuauhtlahtoh<br/><em>(<span class="small">CHIEF</span>)</em></p></td>
</tr>
<tr>
<td valign="top"><p class="table">Sho-sa</p></td>
<td valign="top"><p class="table">Lieutenant<br/>Commander</p></td>
<td valign="top"><p class="table">Major</p></td>
<td valign="top"><p class="table"> </p></td>
</tr>
<tr>
<td valign="top"><p class="table">Thai-i</p></td>
<td valign="top"><p class="table">Lieutenant</p></td>
<td valign="top"><p class="table">Captain</p></td>
<td valign="top"><p class="table">Cuahyahcatl<br/><em>(<span class="small">GREAT CAPTAIN</span>)</em></p></td>
</tr>
<tr>
<td valign="top"><p class="table">Chu-i</p></td>
<td valign="top"><p class="table">Sub-Lieutenant</p></td>
<td valign="top"><p class="table">Lieutenant</p></td>
<td valign="top"><p class="table"> </p></td>
</tr>
<tr>
<td valign="top"><p class="table">Sho-i Ko-hosei</p></td>
<td valign="top"><p class="table">Midshipman</p></td>
<td valign="top"><p class="table"> </p></td>
<td valign="top"><p class="table"> </p></td>
</tr>
<tr>
<td valign="top"><p class="table">Gunso</p></td>
<td valign="top"><p class="table"> </p></td>
<td valign="top"><p class="table">Master Sergeant</p></td>
<td valign="top"><p class="table">Cuauhhuehueh<br/><em>(<span class="small">EAGLE ELDER</span>)</em></p></td>
</tr>
<tr>
<td valign="top"><p class="table">Joto-Heiso</p></td>
<td valign="top"><p class="table">Chief Boatswain</p></td>
<td valign="top"><p class="table"> </p></td>
<td valign="top"><p class="table"> </p></td>
</tr>
<tr>
<td valign="top"><p class="table">Gocho</p></td>
<td valign="top"><p class="table"> </p></td>
<td valign="top"><p class="table">Sergeant</p></td>
<td valign="top"><p class="table">Tequihuah<br/><em>(<span class="small">VETERAN WARRIOR</span>)</em></p></td>
</tr>
<tr>
<td valign="top"><p class="table">Itto-Heiso</p></td>
<td valign="top"><p class="table">Chief Boatswain’s<br/>Mate</p></td>
<td valign="top"><p class="table"> </p></td>
<td valign="top"><p class="table"> </p></td>
</tr>
<tr>
<td valign="top"><p class="table">Heicho</p></td>
<td valign="top"><p class="table"> </p></td>
<td valign="top"><p class="table">Corporal</p></td>
<td valign="top"><p class="table">Yaotequihuah<br/><em>(<span class="small">LEADER OF YOUTHS</span>)</em></p></td>
</tr>
<tr>
<td valign="top"><p class="table">Nitto-Heiso</p></td>
<td valign="top"><p class="table">Boatswain’s mate</p></td>
<td valign="top"><p class="table"> </p></td>
<td valign="top"><p class="table"> </p></td>
</tr>
<tr>
<td valign="top"><p class="table">Ittohei</p></td>
<td valign="top"><p class="table"> </p></td>
<td valign="top"><p class="table">Senior Private</p></td>
<td valign="top"><p class="table">Tiachcuah<br/><em>(<span class="small">OLDER BROTHER</span>)</em></p></td>
</tr>
<tr>
<td valign="top"><p class="table">Itto-Shihei</p></td>
<td valign="top"><p class="table">Spacer</p></td>
<td valign="top"><p class="table"> </p></td>
<td valign="top"><p class="table"> </p></td>
</tr>
<tr>
<td valign="top"><p class="table">Nitohei</p></td>
<td valign="top"><p class="table"> </p></td>
<td valign="top"><p class="table">Private</p></td>
<td valign="top"><p class="table">Telpolcatl<br/><em>(<span class="small">YOUTH</span>)</em></p></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter003.vue?065ac14f